import Flicking from "@egjs/flicking"

export const _Flicking = Flicking
